import { RegionIdMap } from '@/view-models/region'

export const RegionSmartBannerMap: Record<number, string> = Object.freeze({
  [RegionIdMap.Taipei]: 'smart_banner_phone-tw.png',
  [RegionIdMap.Taichung]: 'smart_banner_phone-tw.png',
  [RegionIdMap.TAINAN_KAOHSIUNG]: 'smart_banner_phone-tw.png',
  [RegionIdMap.HONG_KONG]: 'smart_banner_phone-hk.png',
  [RegionIdMap.TOKYO]: 'smart_banner_phone-jp.png',
  [RegionIdMap.KANSAI]: 'smart_banner_phone-jp.png',
  [RegionIdMap.OKINAWA]: 'smart_banner_phone-jp.png',
  [RegionIdMap.SAPPORO]: 'smart_banner_phone-jp.png',
  [RegionIdMap.KualaLumpur]: 'smart_banner_phone-my.png',
  [RegionIdMap.PENANG]: 'smart_banner_phone-my.png',
  [RegionIdMap.CHIANGMAI]: 'smart_banner_phone-th.png',
  [RegionIdMap.Bangkok]: 'smart_banner_phone-th.png',
})

export const LocaleSmartBannerMap: Record<string, string> = Object.freeze({
  'zh-tw': 'smart_banner_phone-tw.png',
  'zh-cn': 'smart_banner_phone-my.png',
  en: 'smart_banner_phone-my.png',
  ja: 'smart_banner_phone-jp.png',
  th: 'smart_banner_phone-th.png',
})
